import React from 'react';
import Action from '@components/Button/Action';
import { supportEmailProps } from '@repo/utils/helpers/preferred-email-client';
import styles from './Help.module.scss';

export default function Help({ next = null, text = 'Next', forceDarkMode = false }) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        Need help? Visit our{' '}
        <a href="https://library.clay.earth/" target="_blank">
          library
        </a>{' '}
        or <a {...supportEmailProps()}>message us</a>.
      </div>
      {next && (
        <Action onClick={next} type="button" forceDarkMode={forceDarkMode}>
          {text}
        </Action>
      )}
    </div>
  );
}
